import { render, staticRenderFns } from "./My_Info.vue?vue&type=template&id=29967814&scoped=true"
import script from "./My_Info.vue?vue&type=script&lang=js"
export * from "./My_Info.vue?vue&type=script&lang=js"
import style0 from "./My_Info.vue?vue&type=style&index=0&id=29967814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29967814",
  null
  
)

export default component.exports